var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isOpen
    ? _c("ModalFullScreen", {
        on: { close: _vm.handleClose },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "flex items-center" },
                    [
                      _c("CircleWithInitials", {
                        staticClass: "mr-2",
                        attrs: { title: _vm.projectTitle },
                      }),
                      _c("h2", { staticClass: "text-md font-bold" }, [
                        _vm._v(_vm._s(_vm.projectTitle)),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "h3",
                    {
                      staticClass:
                        "text-lg py-4 border-b border-gray-200 font-medium",
                    },
                    [_vm._v(" New Group Conversation ")]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _vm.groupConversationUsers.length
                    ? _c(
                        "div",
                        { staticClass: "border-b border-gray-200 py-4" },
                        _vm._l(_vm.checkboxOptions, function (option) {
                          return _c("Checkbox", {
                            key: option.userId,
                            attrs: { id: option.userId, name: option.name },
                            model: {
                              value: option.selected,
                              callback: function ($$v) {
                                _vm.$set(option, "selected", $$v)
                              },
                              expression: "option.selected",
                            },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _c("FormGroup", {
                    staticClass: "mt-4",
                    attrs: { name: "conversation_name" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._v(" Conversation name ")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      128501655
                    ),
                    model: {
                      value: _vm.conversationName,
                      callback: function ($$v) {
                        _vm.conversationName = $$v
                      },
                      expression: "conversationName",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "py-1 flex" },
                    [
                      _c("UiButton", {
                        staticClass: "mr-3",
                        attrs: { variant: "outline", buttonText: "Cancel" },
                        on: { click: _vm.handleClose },
                      }),
                      _c("UiButton", {
                        attrs: {
                          buttonText: "Create",
                          type: "submit",
                          disabled: !_vm.selectedUsers.length,
                        },
                        on: { click: _vm.createGroupConversation },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          672825124
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }